"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function resolveBodyColumns(columns) {
  var ret = [];

  columns.forEach(function (column) {
    // If a column has children, skip cell specific configuration
    if (column.children && column.children.length) {
      ret = ret.concat(resolveBodyColumns(column.children));
    } else {
      ret.push(column);
    }
  });

  return ret;
}

exports.default = resolveBodyColumns;


//////////////////
// WEBPACK FOOTER
// ./~/reactabular-utils/dist/resolve-body-columns.js
// module id = 1421
// module chunks = 0